(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1176],{

/***/ 68718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/ebay-ship-cover-insurance/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-04-08",
      tag: "eBay",
      title: "eBay ShipCover Insurance: Coverages and How To File Claims",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Selling on any online marketplace goes beyond simply closing sales. Preparing the orders, packing them, and shipping them entails ensuring that the parcels are in good condition and delivered correctly to their buyer. This is where insurance comes in, which eBay offers.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "eBay's ShipCover Insurance is the giant e-commerce platform's way of protecting the packages. But how does it work? What is the process when filing claims for lost or damaged parcels? This short guide tells you all these and more."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "ShipCover Insurance"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "You may be thinking to what extent does eBay insure your packages? eBay is clear that coverage is applicable during the transit period. This means starting from when the package leaves your location to the destination where it should arrive."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Keep in mind, though, that the Insurer is not liable for anything more than the cash value, repair cost, declared value, or limit of the package liability."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Why avail of the insurance?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "eBay covers domestic and international packages but is only available when you ship via USPS. The processing of claims is now fatser as it only takes a few days instead of weeks, as expected."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Generally, insurance helps sellers ensure that the package is protected during delivery. Of course, there are times when parcels get mishandled by the courier. With hundreds being shipped each day, packages may inevitably suffer damage."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "This is why insurance can cover any kind of mishandling, especially if these are caused by accidents. Whether by courier or by accident, you can file a claim, and eBay will review it before taking the proper action to pay you for the damages."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Insurance Rates"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "When you print your shipping label on eBay, you can get $1,000 worth of insurance. eBay generally offers low rates so sellers can save up."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "For the rates, USPS Domestic ranges from $0.01-$100 package value with $1.70 seller cost to $900-$1,000 package value with $14.51 seller cost. If you are shipping using USPS International, the rates range from $0.1-$100 package value with $2.83 to $900-$1,000 package value with $17.72 seller cost."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "There are taxes already included in these rates. The first one is the Surplus Line Tax. This applies to California, wherein 3% is paid to the state while the equivalent Surplus Line Stamping Fee amounts to 0.25%. This applies to packages worth greater than $100."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "For those shipping parcels with a value less than $100, the great news is that there is no Stamping Fee for this. This is why sellers should always be careful in weighing the package and registering its weight. Any mistake, especially a great margin or difference, can definitely affect the shipping process and may require you to pay more than you expected."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Countries Excluded from Insurance"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Now, as eBay has policies about taxes and international shipping fees, sellers should take note of which countries are not covered by ShipCover Insurance."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "These are the following countries: Cuba, North Korea, Myanmar, Belarus, Iran, Sudan, Zimbabwe, Syrian Arab Republic, and Ivory Coast."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Take note that some countries have certain policies on international shipping, which may be why eBay is unable to cover insurance for them."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "This list is not exhaustive and may change, so you may want to check eBay's website for updates."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Excluded Items from Insurance"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "As much as sellers want every type of order to be covered by insurance, eBay has placed limitations on certain items."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "This includes those with special value like coins, diamonds, and bullion. Tickets such as admission, lottery, and gift certificates are also on the list. Bonds, stocks, and currencies are not allowed. Even plasma television and monitors are not covered."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "eBay doesn't cover those insufficiently or incorrectly packaged or wrapped parcels. Given this policy, it is your responsibility to ensure that your buyers' orders are securely packed to avoid any damages during shipping."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "You may want to place them in boxes or bubble wrap and wrap them with layers of strong adhesive to ascertain that the items inside will be kept secure no matter who handles them."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Aside from insufficiently wrapped packages, eBay also doesn't cover damages caused by wars, rebellions, atomic fissures, insurrection, and revolution. However, if any nuclear reaction or radioactive forces cause fire, then that is only the time eBay will pay the seller for the damages."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Any instruction from the national government or public authority should also be honored. This applies to confiscated packages for possible contrabands and items that are proven to be illegal. So, you should check the eBay list of prohibited items to avoid any unnecessary hassle and costly fines."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Filing Claims and What Happens After"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "When you have to avail of ShipCover Insurance, you can do so via the eBay website. Make sure that you file within 90 days of the coverage date."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Keep in mind that you are not allowed to file claims earlier than 30 days for lost packages and seven days after the coverage date for damaged parcels."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Once you have accomplished the claim, complete with proper documentation, this will be reviewed by the Parcel Insurance Plan (PIP). It takes them seven business days to do so, and once they approve, you will get paid for the loss."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "You can recover your rights from the Carrier, but this is minus the amount equal to the deductible. This is then transferred to the Insurer."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The entire process may seem daunting, but this is crucial to properly cover your loss or damaged package. Make sure you follow the steps and attend to other requirements instructed by PIP so the processing can be efficient and accomplished right away."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Cross-list to Promote"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "You may be wondering, if certain items are excluded from insurance, then where else can you sell them? This is where cross-posting your listings comes in handy. OneShop is an app you can subscribe to that cross lists your items to other top online marketplaces such as Poshmark, Mercari, and soon, eBay. Each platform has its own insurance policies, so you can check each one out."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Despite the differing policies, what is good is that you can extensively promote your listings to thousands of other potential buyers. OneShop does the cross-promoting, relisting, and even delisting for you. With only a few clicks, you can save time and increase your chances of closing sales."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/ebay-ship-cover-insurance.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "eBay ShipCover Insurance: Coverages and How To File Claims"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "As much as sellers want to avoid parcel loss or damages, accidents happen. Thankfully, eBay has insurance that can protect you\u2013here's how."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/ebay-ship-cover-insurance"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/ebay-ship-cover-insurance"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "eBay ShipCover Insurance: Coverages and How To File Claims"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "As much as sellers want to avoid parcel loss or damages, accidents happen. Thankfully, eBay has insurance that can protect you\u2013here's how."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "April 8th, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "April 8th, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "eBay"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 81102:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/ebay-ship-cover-insurance",
      function () {
        return __webpack_require__(68718);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(81102); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);